export default class InvalidOtpCodeError extends Error {}
